import { useContext, useMemo } from "react"
import { ProgramAndCoursesInfo } from "../../../../../types/gqlTypes/graphql"
import { FeatureFlagContext } from "../../../../mp-core/FeatureFlagProvider"
import { ProgramsContext } from "../../../../mp-shared-components/ready-shared-components/components/Navs"
import { FeatureFlagName } from "../../../../mp-utils/generic-utils/feature-flags/types"
import {
  REPORTING_HIDDEN_PROGRAMS,
  REPORTING_QUESTIONS_AVAILABLE_PROGRAMS
} from "../constants"

export const useReportingProgramAndCourses = () => {
  const { programsAndCourses, programsAndCoursesLoading } =
    useContext(ProgramsContext)
  const { featureFlags, featureFlagsLoading } = useContext(FeatureFlagContext)

  const questionsShowAllProgramsFeatureFlagState =
    !!featureFlags?.[
      FeatureFlagName.reporting_insights_performance_questions_show_all_programs
    ]

  const reportingProgramsAndCourses: ProgramAndCoursesInfo[] = useMemo(() => {
    if (programsAndCoursesLoading) return []

    const filtered = programsAndCourses.filter(
      item =>
        item.program.startsWith("WK") &&
        !REPORTING_HIDDEN_PROGRAMS.includes(item.program)
    )

    return filtered
  }, [programsAndCourses, programsAndCoursesLoading])

  const reportingQuestionsProgramsAndCourses: ProgramAndCoursesInfo[] =
    useMemo(() => {
      if (!!featureFlagsLoading) return []

      if (!!questionsShowAllProgramsFeatureFlagState) {
        return reportingProgramsAndCourses
      }

      return reportingProgramsAndCourses.filter(
        item => !!REPORTING_QUESTIONS_AVAILABLE_PROGRAMS.includes(item.program)
      )
    }, [
      reportingProgramsAndCourses,
      featureFlagsLoading,
      questionsShowAllProgramsFeatureFlagState
    ])

  return {
    reportingProgramsAndCourses,
    reportingQuestionsProgramsAndCourses
  }
}
